import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { AlertComponent } from "./alert/alert.component";
import { FlashcardListComponent } from "./flashcard-list/flashcard-list.component";
import { FlashcardWidgetComponent } from "./flashcard-widget/flashcard-widget.component";
import { FolderWidgetComponent } from "./folder-widget/folder-widget.component";
import { LearnsetWidgetComponent } from "./learnset-widget/learnset-widget.component";
import { LoaderComponent } from "./loader/loader.component";
import { SidebarComponent } from "./sidebar/sidebar.component";
import { TranslateModule } from "@ngx-translate/core";
import { CourseWidgetComponent } from "./course-widget/course-widget.component";
import { AddItemWidgetComponent } from "./add-item-widget/add-item-widget.component";
import { ControlsModule } from "../controls/controls.module";
import { SuccessScreenComponent } from "./success-screen/success-screen.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CoursesListComponent } from "./courses-list/courses-list.component";
import { GlobalFooterComponent } from "./global-footer/global-footer.component";
import { GlobalHeaderComponent } from "./global-header/global-header.component";
import { DividerComponent } from "./divider/divider.component";
import { BottomDialogComponent } from "./bottom-dialog/bottom-dialog.component";
import { ActionButtonsComponent } from "./action-buttons/action-buttons.component";
import { BreadcrumbsComponent } from "./breadcrumbs/breadcrumbs.component";
import { MessageComponent } from "./message/message.component";
import { StreakComponent } from "./streak/streak.component";
import { OpenCardsWidgetComponent } from "./open-cards-widget/open-cards-widget.component";
import { ProgressLoaderComponent } from "./progress-loader/progress-loader.component";
import { EditCourseModule } from "../features/course-view/edit-course/edit-course.module";
import { TablerIconsModule } from "angular-tabler-icons";
import { DueStatePipe } from "../pipes/due-state.pipe";
import { PremiumFeatureDialogComponent } from "./premium-feature-dialog/premium-feature-dialog.component";
import { ProgressBarComponent } from "./progress-bar/progress-bar.component";
import { RadioWidgetSelectionComponent } from "./radio-widget-selection/radio-widget-selection.component";
import { RouterModule } from "@angular/router";
import { OptionToggleComponent } from "./option-toggle/option-toggle.component";
import { RepetitionCountWidgetComponent } from "./repetition-count-widget/repetition-count-widget.component";
import { SwipeDirective } from "../directives/swipe.directive";
import { WeeklyGoalWidgetComponent } from "./weekly-goal-widget/weekly-goal-widget.component";
import { DropdownComponent } from "./dropdown/dropdown.component";
import { MasteredCountWidgetComponent } from "./mastered-count-widget/mastered-count-widget.component";
import { CustomProgressWidgetComponent } from "./custom-progress-widget/custom-progress-widget.component";

@NgModule({
  declarations: [
    AlertComponent,
    FlashcardListComponent,
    FlashcardWidgetComponent,
    FolderWidgetComponent,
    LearnsetWidgetComponent,
    LoaderComponent,
    SidebarComponent,
    CourseWidgetComponent,
    AddItemWidgetComponent,
    SuccessScreenComponent,
    CoursesListComponent,
    GlobalFooterComponent,
    GlobalHeaderComponent,
    DividerComponent,
    BottomDialogComponent,
    ActionButtonsComponent,
    BreadcrumbsComponent, 
    MessageComponent,
    StreakComponent,
    OpenCardsWidgetComponent,
    ProgressLoaderComponent,
    PremiumFeatureDialogComponent,
    ProgressBarComponent,
    RadioWidgetSelectionComponent,
    OptionToggleComponent,
    RepetitionCountWidgetComponent,
    WeeklyGoalWidgetComponent,
    DropdownComponent,
    MasteredCountWidgetComponent,
    CustomProgressWidgetComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    ControlsModule,
    EditCourseModule,
    TablerIconsModule,
    DueStatePipe,
    RouterModule,
    FormsModule,
    SwipeDirective
],
  exports: [
    AlertComponent,
    FlashcardListComponent,
    FlashcardWidgetComponent,
    FolderWidgetComponent,
    LearnsetWidgetComponent,
    LoaderComponent,
    SidebarComponent,
    CourseWidgetComponent,
    AddItemWidgetComponent,
    SuccessScreenComponent,
    CoursesListComponent,
    GlobalFooterComponent,
    GlobalHeaderComponent,
    DividerComponent,
    BottomDialogComponent,
    ActionButtonsComponent,
    BreadcrumbsComponent,
    MessageComponent,
    StreakComponent,
    OpenCardsWidgetComponent,
    ProgressLoaderComponent,
    PremiumFeatureDialogComponent,
    ProgressBarComponent,
    RadioWidgetSelectionComponent,
    OptionToggleComponent,
    RepetitionCountWidgetComponent,
    WeeklyGoalWidgetComponent,
    DropdownComponent,
    MasteredCountWidgetComponent,
    CustomProgressWidgetComponent
  ]
})
export class SharedModule { }